import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-approval-grid',
  templateUrl: './approval-grid.component.html',
  styleUrls: ['./approval-grid.component.css']
})
export class ApprovalGridComponent implements OnInit {

title="View Approvals";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/landprocurement/approval/approval-grid/approval-grid.component.ts